import { Endpoint } from '@square/ignition';
import { ApiExplorerInput } from '@squareup/dex-types-shared-api-explorer';
import { InputReducerAction } from '@squareup/dex-ui-shared-api-explorer-providers';
import { persistApiExplorerInputToStorage } from '@squareup/dex-utils-shared-api-explorer';
import { log } from '@squareup/dex-utils-shared-logging';
import { immutableJSONPatch } from 'immutable-json-patch';

const inputReducer =
  (endpoint: Endpoint | undefined) =>
  (state: ApiExplorerInput, action: InputReducerAction) => {
    if (action.type === 'set') {
      persistApiExplorerInputToStorage(endpoint, action.newState);
      return action.newState;
    } else if (action.type !== 'patch') {
      throw new Error(
        `Unknown action type: ${(action as { type: string }).type}`
      );
    }

    try {
      const newState = immutableJSONPatch<ApiExplorerInput, ApiExplorerInput>(
        state,
        [action.operation]
      );

      persistApiExplorerInputToStorage(endpoint, newState);
      return newState;
    } catch (error) {
      log.error(
        `[API Explorer] - Could not update state of input - ${JSON.stringify(
          action.operation
        )}`,
        undefined,
        error as Error
      );
      return state;
    }
  };

export { inputReducer };
